module.exports = __webpack_public_path__ + "static/media/class3.a47efb51.jpg";